module.exports = __webpack_public_path__ + "img/photo-05.961fc66e.jpg";